import arrowIcon from '../assets/icons/arrow.svg';
import classes from './WorkAtIceberryRow.module.scss';
import yellowArrowIcon from '../assets/images/yellow-arrow.webp';
import { motion } from 'framer-motion';

const WorkAtIceberryRow: React.FC<{
  title: string;
  text: string;
  additionalClasses?: string;
}> = props => {
  return (
    <motion.div
      className={`row space-between ${classes['row-extension']} ${props.additionalClasses}`}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      viewport={{ once: true, margin: '-100px' }}
    >
      <div className='col-10 col-md-5 d-flex d-md-flex'>
        <h5 className={classes['self-center']}>{props.title}</h5>
      </div>
      <div className={`col-2 d-flex ${classes['image-container']}`}>
        <img
          src={arrowIcon}
          alt='An arrow'
          className={`${classes['black-arrow']} ${classes['self-end']}`}
        />
        <img
          src={yellowArrowIcon}
          alt='An arrow'
          className={`${classes['yellow-arrow']} ${classes['self-center']}`}
        />
      </div>
      <div className='col-8 col-md-5'>
        <p className='text'>{props.text}</p>
      </div>
    </motion.div>
  );
};

export default WorkAtIceberryRow;
